import i18next from 'i18next';

const DEFAULT_FRACTION = 2;

export function formatNumberAsCurrency(
  value: number,
  options?: { locale?: string; minimum?: number; maximum?: number }
) {
  const {
    locale = i18next.language,
    minimum = DEFAULT_FRACTION,
    maximum = DEFAULT_FRACTION,
  } = options ?? {};

  const currencyFormat = new Intl.NumberFormat(locale, {
    minimumFractionDigits: minimum,
    maximumFractionDigits: maximum,
  });
  return value != null ? currencyFormat.format(value) : '';
}
